var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-backgroud",staticStyle:{"height":"200px","width":"100%","background-color":"rgba(0, 0, 0, 0.3)"}},[_c('img',{attrs:{"src":require(("../assets/" + _vm.title_img_src))}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44cbdc42","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header-Title.vue
// module id = 1xIV
// module chunks = 1